module.exports = __webpack_public_path__ + "static/img/division_3.bc4222d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/fortnite/division_3.svg
// module id = Wdqt
// module chunks = 35